'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styletronUtils = require('styletron-utils');

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * @class StyletronProvider
 * @packagename styletron-react
 * @description Provides a Styletron instance to descendant styled components via context
 * @example
 * const Styletron = require('styletron');
 *
 * function render() {
 *   return React.renderToString(
 *     <StyletronProvider styletron={new Styletron()}>
 *       <App/>
 *     </StyletronProvider>
 *   );
 * }
 *
 * @property {object} styletron - Styletron instance
 * @property {ReactElement} children - children
 * @extends ReactClass
 */

var StyletronProvider =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(StyletronProvider, _React$Component);

  var _proto = StyletronProvider.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      styletron: this.styletron
    };
  };

  function StyletronProvider(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.styletron = props.styletron;
    return _this;
  }

  _proto.render = function render() {
    return React.Children.only(this.props.children);
  };

  return StyletronProvider;
}(React.Component);

StyletronProvider.propTypes = {
  styletron: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired
};
StyletronProvider.childContextTypes = {
  styletron: PropTypes.object.isRequired
};

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var STYLETRON_KEY = '__STYLETRON';
/**
 * Helper function to create styled element components
 * @packagename styletron-react
 * @param  {String|function} base        Tag name or component
 * @param  {function|object} styleFn     Style object or function that returns a style object
 * @param  {function}        assignProps Function that consumes the style result and props and returns an object with new props
 * @return {function}                    Component
 * @example
 */

function core(base, style, assignProps) {
  if (typeof base === 'function' && base[STYLETRON_KEY]) {
    var _base$STYLETRON_KEY = base[STYLETRON_KEY],
        tag = _base$STYLETRON_KEY.tag,
        styles = _base$STYLETRON_KEY.styles; // Styled component

    return createStyledElementComponent(tag, styles.concat(style), assignProps);
  }

  if (typeof base === 'string' || typeof base === 'function') {
    // Tag name or non-styled component
    return createStyledElementComponent(base, [style], assignProps);
  }

  throw new Error('`styled` takes either a DOM element name or a component');
}

function createStyledElementComponent(base, stylesArray, assignProps) {
  function StyledElement(props, context) {
    var ownProps = assign({}, props);
    delete ownProps.innerRef;
    var styleResult = {};
    StyledElement[STYLETRON_KEY].styles.forEach(function (style) {
      if (typeof style === 'function') {
        assign(styleResult, style(ownProps, context));
      } else if (_typeof(style) === 'object') {
        assign(styleResult, style);
      }
    });
    var elementProps = assignProps(context.styletron, styleResult, ownProps);
    elementProps = omit$Props(elementProps);

    if (props.innerRef) {
      elementProps.ref = props.innerRef;
    }

    return React.createElement(StyledElement[STYLETRON_KEY].tag, elementProps);
  }

  StyledElement[STYLETRON_KEY] = {
    tag: base,
    styles: stylesArray
  };
  StyledElement.contextTypes = {
    styletron: PropTypes.object
  };

  if (process.env.NODE_ENV !== "production") {
    var name = base.displayName ? base.displayName : typeof base === 'function' ? base.name : base;
    StyledElement.displayName = "Styled" + (name ? "(" + name + ")" : '');
  }

  return StyledElement;
}

function assign(target, source) {
  for (var key in source) {
    target[key] = source[key];
  }

  return target;
}

function omit$Props(source) {
  var result = {};

  for (var key in source) {
    if (key[0] !== '$') {
      result[key] = source[key];
    }
  }

  return result;
}

/**
 * Helper function to create styled element components
 * @packagename styletron-react
 * @param  {String|function} base     Tag name or styled element component
 * @param  {function|object} styleFn  Style object or function that returns a style object
 * @return {function}                 Styled element component
 * @example
 * import {styled} from 'styletron-react';
 *
 * const Panel = styled('div', {
 *   backgroundColor: 'lightblue',
 *   fontSize: '12px'
 * });
 *
 * <Panel>Hello World</Panel>
 * @example
 * import {styled} from 'styletron-react';
 *
 * const Panel = styled('div', (props) => ({
 *   backgroundColor: props.alert ? 'orange' : 'lightblue',
 *   fontSize: '12px'
 * }));
 *
 * <Panel alert>Danger!</Panel>
 * @example
 * import {styled} from 'styletron-react';
 *
 * const DeluxePanel = styled(Panel, (props) => ({
 *   backgroundColor: props.alert ? 'firebrick' : 'rebeccapurple',
 *   color: 'white',
 *   boxShadow: '3px 3px 3px darkgray'
 * }));
 *
 * <DeluxePanel>Bonjour Monde</DeluxePanel>
 */

function styled(base, style) {
  return core(base, style, assignProps);
}

function assignProps(styletron, styleResult, ownProps) {
  var styletronClassName = styletronUtils.injectStylePrefixed(styletron, styleResult); // Skipping cloning of `ownProps` since that's already done internally

  if (ownProps.styleProps) {
    delete ownProps.styleProps;
  }

  ownProps.className = ownProps.className ? ownProps.className + " " + styletronClassName : styletronClassName;
  return ownProps;
}

exports.StyletronProvider = StyletronProvider;
exports.core = core;
exports.styled = styled;
//# sourceMappingURL=browser.es5.js.map



//////////////////
// WEBPACK FOOTER
// ./~/styletron-react/dist/browser.es5.js
// module id = 6
// module chunks = 168707334958949